/* import __COLOCATED_TEMPLATE__ from './care-recipient-selector.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();